module.exports = __webpack_public_path__ + "img/main_product.3d4db3da.jpg";